import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomerService } from "src/app/services/customer.service";
// import { ServiceCenterService } from "src/app/services/service-center.service";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditDeleteActionsRenderer } from '../../shared/ag-grid/cell-renderers/edit-delete.component';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NetworkService } from "src/app/services/network.service";
import { CreditControlService } from "src/app/services/system-config/credit-control/creditcontrol";
import { AppCoreService } from "src/app/services/app-core.service";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { Title } from "@angular/platform-browser";
import { Utilities } from "src/app/models/utilities";

@Component({
  selector: 'app-creditcontrol',
  templateUrl: './creditcontrol.component.html',
  styleUrls: ['./creditcontrol.component.scss']
})
export class CreditControlComponent implements OnInit, AfterViewInit {
  CreditControlForm: FormGroup;
  notificationForm: FormGroup;
  isFormSubmitted: boolean;
  formSubmitted: boolean;
  Id: number;
  countList: any[] = [];
  customerList: any[] = [];
  serviceCenterList: any[] = [];
  typeList: any[] = [{ name: 'Customer' }, { name: 'Service Center' }];
  percentageList: number[] = [100, 95, 90, 85, 80, 75, 70];

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight'
  }
  columnDefs = [
    { headerName: 'Type', field: 'type', },
    { headerName: 'Service Center', field: 'servicecentername' },
    { headerName: 'Customer', field: 'customername' },
    { headerName: 'Credit Limit', field: 'creditamount' },
    { headerName: 'Usage Limit (%)', field: 'usagelimit' },
    { headerName: 'Available Credit', field: 'creditavailable' },
    { headerName: 'Balance', field: 'balanceamount' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      editable: false,
      sortable: false,
      filter: false,
      pinned: 'right',
      maxWidth: 80
    },
  ];
  selectedSCId: any;
  rowData = [];
  isCustomerType: boolean = false;
  isEditMode = false;
  useEnterKey: any;
  usedAmount: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private creditControlService: CreditControlService,
    private customerService: CustomerService,
    private networkService: NetworkService,
    private ngxLoaderService: NgxUiLoaderService,
    private appCoreService: AppCoreService,
    private configService: ConfigService,
    private titleService: Title,
    private utilities: Utilities,

  ) {
    titleService.setTitle('Credit Control');
    this.context = { componentParent: this };
  }

  ngOnInit(): void {
    this.CreditControlForm = this.formBuilder.group({
      ddlType: [null, Validators.required],
      ddlServiceCenter: [null, Validators.required],
      ddlCustomer: [null, Validators.required],
      txtCreditLimit: [null, Validators.compose([Validators.required, Validators.max(10000000000), Validators.min(0)])],
      txtUsageLimit: [100, Validators.compose([Validators.required, Validators.max(100)])],
    });

    this.notificationForm = this.formBuilder.group({
      txtUsageLimit: [null]
    });

    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
        this.bindCustomer();
        this.bindServiceCenter();
        this.bindCreditControl();
      });
    }
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.CreditControlForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Credit Control');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  savePercentage() {
    const reqBody = {
      type: 'creditusage',
      configDetails: {
        percentageusagelimit: this.notificationForm.get('txtUsageLimit').value
      }
    }
    this.ngxLoaderService.start();
    try {
      this.configService.ManageConfigs(reqBody).subscribe(res => {
        if (res?.success) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage('Record saved successfully');
        }
      })
    } catch (error) {
      this.ngxLoaderService.stop();
    }
  }

  onChangeType() {
    if (this.CreditControlForm.get('ddlType').value === 'Customer') {
      this.isCustomerType = true;
      this.CreditControlForm.get('ddlCustomer').setValidators([Validators.required]);
      this.CreditControlForm.get('ddlServiceCenter').reset();
      this.CreditControlForm.get('ddlServiceCenter').clearValidators();
    } else if (this.CreditControlForm.get('ddlType').value === 'Service Center') {
      this.isCustomerType = false;
      this.CreditControlForm.get('ddlCustomer').clearValidators();
      this.CreditControlForm.get('ddlCustomer').reset();
      this.CreditControlForm.get('ddlServiceCenter').setValidators([Validators.required]);
    }
    else {
      this.isCustomerType = false;
      this.CreditControlForm.get('ddlCustomer').reset();
      this.CreditControlForm.get('ddlServiceCenter').reset();
    }
    this.CreditControlForm.get('ddlCustomer').updateValueAndValidity();
    this.CreditControlForm.get('ddlServiceCenter').updateValueAndValidity();
  }

  editAction(cell: any) {
    if (cell.id) {
      // console.log(cell);
      this.Id = cell.id;
      this.isEditMode = true;
      this.bindCustomer();
      this.bindServiceCenter();
      this.CreditControlForm.get('ddlType').disable();
      if (cell?.customerid) {
        this.CreditControlForm.get('ddlCustomer').disable();
        this.CreditControlForm.get('ddlServiceCenter').enable();
      } else {
        this.CreditControlForm.get('ddlCustomer').enable();
        this.CreditControlForm.get('ddlServiceCenter').disable();
      }
      this.CreditControlForm.patchValue({
        ddlType: cell.type,
        ddlServiceCenter: cell.servicecenterid,
        ddlCustomer: cell.customerid,
        txtCreditLimit: cell.creditamount,
        txtUsageLimit: cell.usagelimit,
      });
      const row = this.rowData.find(x => x.id === this.Id);
      this.usedAmount = Math.abs(Number(row?.creditavailable) - Number(row?.balanceamount));
      this.onChangeType();
    }
  }

  bindCustomer() {
    this.customerService.GetAll({ scid: this.selectedSCId, isactive: this.isEditMode ? false : true }).subscribe((res) => {
      if (res && res.success) {
        this.customerList = res.data;
      }
    })
  }

  bindServiceCenter() {
    this.networkService.GetAllServiceCenters({ isactive: this.isEditMode ? false : true }).subscribe((res) => {
      if (res && res.success) {
        this.serviceCenterList = res.data;
      }
    })
  }

  bindCreditControl(refresh = false) {
    this.ngxLoaderService.start();
    try {
      this.creditControlService.GetAllList({ scid: this.selectedSCId, refresh: refresh }).subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.rowData = res.data;

          // Find service center details safely
          const row = this.rowData.find(x => x.servicecenterid === this.appCoreService.GetUserData().selectedServiceCenter);

          if (row) {  // Ensure row is found before accessing properties
            const creditDetails = {
              limit: row.creditavailable || 0,  // Ensure a default value
              balance: row.balanceamount || 0,
              used: Math.max(0, (row.creditavailable || 0) - (row.balanceamount || 0))
            };

            this.appCoreService.setCreditDetails(creditDetails);
          } else {
            console.warn("Service Center not found in credit control data.");
          }
        }
      }, error => {
        this.ngxLoaderService.stop();
        console.error("Error fetching credit control data:", error);
      });
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error("Unexpected error in bindCreditControl:", e);
    }
  }


  upsert() {
    this.isFormSubmitted = true;
    try {
      if (this.CreditControlForm.valid) {
        const creditamount = parseFloat(this.CreditControlForm.get('txtCreditLimit')?.value) || 0;
        const usagelimit = Number(this.CreditControlForm.get('txtUsageLimit')?.value) || 0;
        const creditavailable = creditamount * usagelimit * 0.01;

        const creditdetails = {
          id: this.Id ?? null,
          type: this.CreditControlForm.get('ddlType')?.value,
          customerid: this.CreditControlForm.get('ddlCustomer')?.value,
          servicecenterid: this.CreditControlForm.get('ddlServiceCenter')?.value,
          creditamount,
          usagelimit,
          balanceamount: 0, // Default
          creditavailable
        };

        if (this.isEditMode) {
          const row = this.rowData.find(x => x.id === this.Id);
          if (row) {
            // Adjust credit amount properly
            creditdetails.creditamount = Number(row?.creditamount) + creditamount;
            creditdetails.creditavailable = Number(row?.creditavailable) + creditavailable;

            // **Fix Balance Calculation:**
            const previousBalance = Number(row?.balanceamount) || 0;
            const previousCreditAvailable = Number(row?.creditavailable) || 0;
            const balanceDifference = creditdetails.creditavailable - previousCreditAvailable;
            creditdetails.balanceamount = previousBalance + balanceDifference;
          }

          this.usedAmount = Math.abs(Number(row?.creditavailable) - Number(row?.balanceamount));
          if (creditdetails.creditamount < this.usedAmount) {
            return this.appCoreService.showMessage('Cannot set credit amount less than used.', 'Error', 'error');
          }
        } else {
          // **Fix Balance Calculation in Create Mode**
          creditdetails.balanceamount = creditavailable;
        }

        // console.log('creditdetails', creditdetails);

        this.ngxLoaderService.start();
        if (this.isEditMode) {
          this.creditControlService.Update(creditdetails).subscribe((res) => {
            if (res?.success) {
              this.ngxLoaderService.stop();
              this.openConfirmationDialog("Record Saved Successfully");
              this.resetForm();
              this.isEditMode = false;
            }
          });
        } else {
          this.creditControlService.Add(creditdetails).subscribe((res) => {
            if (res) {
              this.ngxLoaderService.stop();
              if (!res?.success && res.data?.err_msg) {
                return this.appCoreService.showMessage(res.data?.err_msg, 'Error', 'error')
              }
              if (res?.success) {
                this.openConfirmationDialog("Record Saved Successfully");
                this.resetForm();
              }
            }
          });
        }
      }
    }
    catch (err) {
      this.ngxLoaderService.stop();
      console.error(err);
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  deleteAction(cell: any) {
    if (cell && cell.id) {
      this.deleteConfirmationDialog('Are you sure you want to delete ?', cell.id);
    }
  }

  async openConfirmationDialog(msg: any,) {
    const res = await Swal.fire({
      // title: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (res.isConfirmed) {
      this.bindCreditControl(true);
    }
  }


  async deleteConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      // call delete api
      this.deleteRecord(id);

    }
  }

  deleteRecord(id) {
    this.ngxLoaderService.start();
    try {
      if (id) {
        this.creditControlService.DeleteById(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.bindCreditControl();
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  resetForm(): void {
    this.isFormSubmitted = false;
    this.CreditControlForm.reset();
    this.CreditControlForm.get('txtUsageLimit').setValue(100);
    this.CreditControlForm.get('ddlType').enable();
    this.isEditMode = false;
    this.Id = null;
  }
}